import { useEffect, useRef, useState } from "react";
import {
	type Location,
	Route,
	Routes,
	useLocation,
	useNavigate,
	useNavigationType,
} from "react-router-dom";
import "./App.css";
import toukoruuImage from "./assets/toukoruu.png";
import TimelinePage from "./components/TimelinePage";

type TransitionPhase = "idle" | "exit" | "enter";

const TRANSITION_MS = 360;

function HomePage({ onOpenTimeline }: { onOpenTimeline: () => void }) {
	return (
		<section className="page page-home">
			<main className="page-shell">
				<button
					className="image-button"
					type="button"
					onClick={onOpenTimeline}
					aria-label="Open relationship timeline"
				>
					<div className="image-frame">
						<div className="image-backdrop" aria-hidden="true" />
						<img
							className="hero-image"
							src={toukoruuImage}
							alt="Toukoruu illustration"
						/>
					</div>
				</button>
			</main>
		</section>
	);
}

function AnimatedRoutes() {
	const navigate = useNavigate();
	const location = useLocation();
	const navigationType = useNavigationType();
	const [displayedLocation, setDisplayedLocation] =
		useState<Location>(location);
	const [transitionPhase, setTransitionPhase] =
		useState<TransitionPhase>("idle");
	const [transitionDirection, setTransitionDirection] = useState<
		"forward" | "backward"
	>("forward");
	const timeoutRef = useRef<number | null>(null);

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				window.clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	useEffect(() => {
		if (location.key === displayedLocation.key) {
			return;
		}

		setTransitionDirection(navigationType === "POP" ? "backward" : "forward");
		setTransitionPhase("exit");

		if (timeoutRef.current) {
			window.clearTimeout(timeoutRef.current);
		}

		timeoutRef.current = window.setTimeout(() => {
			setDisplayedLocation(location);
			setTransitionPhase("enter");
			timeoutRef.current = window.setTimeout(() => {
				setTransitionPhase("idle");
				timeoutRef.current = null;
			}, TRANSITION_MS);
		}, TRANSITION_MS);
	}, [displayedLocation.key, location, navigationType]);

	return (
		<div
			className={`route-stage phase-${transitionPhase} direction-${transitionDirection}`}
		>
			<Routes location={displayedLocation}>
				<Route
					path="/"
					element={<HomePage onOpenTimeline={() => navigate("/almanakka")} />}
				/>
				<Route
					path="/almanakka"
					element={<TimelinePage onGoHome={() => navigate("/")} />}
				/>
			</Routes>
		</div>
	);
}

function App() {
	return <AnimatedRoutes />;
}

export default App;
